// Translations
import landing from '../views/landing/translations/ar'

// Translation: Terms of service (Arabic)
export default Object.freeze({
	name: '',
	views: { landing }
})
